import React from "react";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";

import App from "./App";
import {
  BugsnagWrapper,
  ReduxWrapper,
  QueryWrapper,
  AlertWrapper,
} from "wrappers";

import "./scss/style.scss";
import { StompProvider } from "wrappers/StompContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BugsnagWrapper>
      <ReduxWrapper>
        <QueryWrapper>
          <BrowserRouter>
            <AlertWrapper>
            <StompProvider>
              <App />
              </StompProvider>
            </AlertWrapper>
          </BrowserRouter>
        </QueryWrapper>
      </ReduxWrapper>
    </BugsnagWrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
